import { render } from "./CardTitle.vue?vue&type=template&id=498ea6d8"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\PA\\endocorpusa\\web\\app\\plugins\\pa-teams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/cards/CardTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "498ea6d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('498ea6d8', __exports__)) {
    api.reload('498ea6d8', __exports__)
  }
  
  module.hot.accept("./CardTitle.vue?vue&type=template&id=498ea6d8", () => {
    api.rerender('498ea6d8', render)
  })

}


export default __exports__